import axios, { AxiosRequestConfig } from "axios";
import { trace as startTrace } from "firebase/performance";
import { perf } from "../../utils/firebase";

export const getCategory = async () => {
  const url = `${process.env.REACT_APP_GCP_BASE_URL}/glamlab/api/hair/v4/categories`;

  const axiosConfig: AxiosRequestConfig = {
    url: url,
    method: "GET",
    params: null,
    headers: {
      "x-api-key": process.env.REACT_APP_GCP_API_KEY,
      "Content-Type": "application/json",
    },
  };

  const trace = startTrace(perf, `Api call: ${url}`);
  trace.start();

  try {
    const response = await axios(axiosConfig);
    return response;
  } catch (error) {
    throw error;
  } finally {
    trace.stop();
  }
};

export const getCategoryV5 = async (experience: string | null) => {
  const url = `${process.env.REACT_APP_GCP_BASE_URL}/glamlab/api/hair/v5/categories?experience=${experience}`;

  const axiosConfig: AxiosRequestConfig = {
    url: url,
    method: "GET",
    params: null,
    headers: {
      "x-api-key": process.env.REACT_APP_GCP_API_KEY,
      "Content-Type": "application/json",
    },
  };

  const trace = startTrace(perf, `Api call: ${url}`);
  trace.start();

  try {
    const response = await axios(axiosConfig);
    return response;
  } catch (error) {
    throw error;
  } finally {
    trace.stop();
  }
};
